import { Backdrop, CircularProgress } from "@material-ui/core";
import React from "react";

interface Props {
    isLoading: boolean;
}

const Spinner = ({ isLoading }: Props): React.ReactElement => {
    return (
        <Backdrop open={isLoading} style={{ zIndex: 1 }}>
            <CircularProgress size="70px" style={{ color: "#ffd17d" }} className="progress" />
        </Backdrop>
    );
};

export default Spinner;
